// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__3itC4","radioRow":"SimpleQuestionBuilderModal_radioRow__1to-6"};